import * as fromUI from '../actions/ui.actions';

export interface UIState {
    isLoading: boolean;
    errorMessage?: string;
    actions: string[];
}

const initState: UIState = {
    isLoading: false,
    actions: []
};

export function uiReducer( state: UIState = initState, action: fromUI.uiActions): UIState {
    switch ( action.type ) {

    case fromUI.ADD_ACTION:
      return { ...state, actions: [ ...state.actions, action.payload ] };

    case fromUI.REMOVE_ACTION:
      return { ...state, actions: state.actions.filter((id) => {console.log('ppp',id,action.payload); return id !== action.payload; }) };

    case fromUI.ACTIVATE_LOADING:
        console.log('activate loading');
        return {
            ...state,
            isLoading: true
        };

    case fromUI.DEACTIVATE_LOADING: {
        if ( action.payload ) {
            return {
                ...state,
                isLoading: false,
                errorMessage: action.payload
            };
        } else {
            return {
                ...state,
                isLoading: false
            };
        }
    }

    default:
        return state;
    }
}
